module.exports = __webpack_public_path__ + "static/media/BwGlennSans900.410e6ac7.woff";